/* eslint-disable @typescript-eslint/no-explicit-any */
import { OctoLink } from "@octopusdeploy/utilities";
import type { Client } from "../client";
import { Repository } from "../repository";
import type { ApiKeyCreatedResource, ApiKeyResource, LoginCommand, ResourceCollection, SpaceResource, UserResource } from "../resources";
import type { AccessTokenResource } from "../resources/accessTokenResource";
import { BasicRepository } from "./basicRepository";
export class UserRepository extends BasicRepository<UserResource, UserResource> {
    constructor(client: Client) {
        super("Users", client);
    }
    signIn(loginCommand: LoginCommand): Promise<UserResource> {
        return this.client.post<UserResource>(this.client.getLink("SignIn"), loginCommand).then((authenticatedUser) => {
            const antiforgeryToken = this.client.getAntiforgeryToken();
            if (antiforgeryToken) {
                return authenticatedUser;
            }
            else {
                throw new Error(`The required anti-forgery cookie is missing. Perhaps your browser or another network device is blocking cookies? See ${OctoLink.Create("CSRE")} for more details and troubleshooting.`);
            }
        });
    }
    signOut() {
        return this.client.post(this.client.getLink("SignOut"), {});
    }
    getCurrent() {
        return this.client.get<UserResource>(this.client.getLink("CurrentUser"));
    }
    getSpaces(user: UserResource) {
        return this.client.get<SpaceResource[]>(user.Links["Spaces"]);
    }
    createApiKey(user: UserResource, purpose: any, expires: Date | null): Promise<ApiKeyCreatedResource> {
        return this.client.post(user.Links["ApiKeys"], { Purpose: purpose, Expires: expires });
    }
    listApiKeys(user: UserResource): Promise<ResourceCollection<ApiKeyResource>> {
        return this.client.get(user.Links["ApiKeys"], { take: Repository.takeAll });
    }
    revokeApiKey(apiKey: ApiKeyResource) {
        return this.client.del(apiKey.Links["Self"]);
    }
    register(registerCommand: any) {
        return this.client.post(this.client.getLink("Register"), registerCommand);
    }
    getTriggers(user: UserResource) {
        return this.client.get(user.Links["Triggers"]);
    }
    revokeSessions(user: UserResource) {
        return this.client.put(user.Links["RevokeSessions"]);
    }
    generateAccessToken(): Promise<AccessTokenResource> {
        return this.client.post(this.client.getLink("AccessToken"));
    }
}
